import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Image } from 'components';
import { media } from "utils/media";
import mdToHtml from "../utils/mdToHtml";

const SectionPricing = ({ className, content, locale, step }) => {
  let localContent = null;
  switch(locale) {
    case 'uk':
      localContent = content.contentUk
      break;
    case 'en':
      localContent = content.contentEn
      break;
    case 'se':
      localContent = content.contentSe
      break;
    default:
      localContent = null;
      break;
  }
  return(<>
    <div className={cx('section-pricing', [className])}>
      <div className='section-media'>
        <Image url={ media(content.image) } alt='Smilbox' />
      </div>
      <div className='section-text'>
        <h3>Step { step }</h3>
        <div className='mt-20' dangerouslySetInnerHTML={{ __html: mdToHtml(localContent) }} />
      </div>
    </div>

    <div className='section-pricing-icons'>
      <p className='mb-20'><b>{ content.iconTitle }</b></p>
      <div className='flex'>
      {content.icon1 &&
            <Fragment>
                <div className='icon-wrapper'>
                    <Image url={ media(content.icon1) } alt={content.icon1Text} />
                    <p dangerouslySetInnerHTML={{ __html: mdToHtml(content.icon1Text) }} />
                </div>
            </Fragment>
        }
        {content.icon2 &&
            <Fragment>
                <div className='icon-wrapper'>
                    <Image url={ media(content.icon2) } alt={content.icon2Text} />
                    <p dangerouslySetInnerHTML={{ __html: mdToHtml(content.icon2Text) }} />
                </div>
            </Fragment>
        }
        {content.icon3 &&
            <Fragment>
                <div className='icon-wrapper'>
                    <Image url={ media(content.icon3) } alt={content.icon3Text} />
                    <p dangerouslySetInnerHTML={{ __html: mdToHtml(content.icon3Text) }} />
                </div>
            </Fragment>
        }
      </div>
    </div>

    <hr className='fvw' />
  </>)
};

SectionPricing.propTypes = {
    className: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    step: PropTypes.string.isRequired
};

SectionPricing.defaultProps = {
    className: '',
    content: {},
    locale: '',
    step: ''
};

export default SectionPricing;
